<template>
  <div class="Release" v-loading="loading">
    <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
      <el-menu-item index="1">发布学术资源</el-menu-item>
      <el-menu-item index="2">发布学术快讯</el-menu-item>
    </el-menu>
    <el-form ref="form" :model="form">
      <el-form-item label>
        <span>
          <span style="color:red;">*</span>
          {{ artice }}
        </span>
        <el-input v-model="form.title" maxlength="30"
          placeholder="30个字以内"></el-input>
      </el-form-item>
      <el-form-item label v-if="show">
        <span>
          <span style="color:red;">*</span>简介
        </span>
        <el-input v-model="form.intro" placeholder="30个字以内" oninput="if(value.length>20)value = value.slice(0,30)"></el-input>
      </el-form-item>

      <el-form-item label>
        <span>{{ articecn }}</span>

        <!-- 富文本 -->
        <editor-bar v-model="form.content" :isClear="isClear"></editor-bar>

        <!-- 附件上传 -->
        <el-upload :action="surl" style="margin-top:10px"
          accept=".jpg, .jpeg, .png, .gif, .bmp, .pdf, .JPG, .JPEG, .PBG, .GIF, .BMP, .PDF, .docx ,.mp4"
          :on-success="handlePreview" :on-remove="handleRemove" :before-remove="beforeRemove">
          <i class="el-icon-paperclip"></i>
          <span class="fenmian">上传附件</span>
        </el-upload>

        <!-- 上传封面图片 -->
        <div class="picture" v-show="show">
          <span class="fenmian">(请选择文章的封面图片，否则系统自动默认一张图片)</span>
          <el-upload :action="surl" accept=".jpg, .jpeg, .png, .gif, .bmp, .pdf, .JPG, .JPEG, .PBG"
            list-type="picture-card" :on-preview="handlePictureCardPreview" :on-remove="handleRemove"
            :on-success="PICsuccess" :limit="1" class="Imege">
            <i class="up-img"></i>
          </el-upload>
          <!-- img-src -->
          <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt />
          </el-dialog>
        </div>
      </el-form-item>

      <el-form-item label>
        <span>引用其他外部知识：</span>
        <el-input v-model="form.reference"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">发布</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import EditorBar from "@/components/wangEnduit/index";
import api from '@/services/config.js'
import {publishWK} from '@/services/'

export default {
  components: { EditorBar },
  data() {
    return {
      userInfo: {},


      loading: false, //是否显示正在加载中
      activeIndex: "1",
      show: true,
      isClear: false,
      detail: "",
      dialogImageUrl: "", //封面图片
      dialogVisible: false,
      artice: "标题",
      articecn: "描述",
      limt: true,
      form: {
        title: "",    //主题
        intro: "",     //简介  
        content: "",    //内容
        img: "",     //主题图片
        reference: "",   //外部链接
        file: "",    //附件
      },

    };
  },
  created() {
    let ui = sessionStorage.getItem('userInfo');
    try {
      if (ui) {
        this.userInfo = JSON.parse(ui);
      }
    } catch (error) {

    }
    this.surl = api.concat("/resource/fileUp");
  },


  methods: {

    //点击文件列表中已上传的文件时的钩子（图片）
    handlePictureCardPreview(file) {
      this.form.img = file.data;
      this.dialogVisible = true;
    },

    //上传图片成功后返回的数据（图片）
    PICsuccess(file, fileList) {
      this.form.img = file.data;
    },


    //发布文章还是快讯
    handleSelect(key, keyPath) {
      switch (keyPath[0]) {
        case "1":
          this.show = true;
          this.form.active = "1";
          this.artice = "标题";
          this.articecn = "描述";
          break;
        case "2":
          this.show = false;
          this.form.active = "2";
          this.artice = "标题";
          this.articecn = "描述";
          break;
      }
    },

    //点击发布
    onSubmit() {
      let token = localStorage.getItem('token');
      let {title,intro,content,reference,file,img} = this.form
      if (!token) {
        this.$message({
          message: "请先登录",
          type: "warning"
        });
        return false;
      }

      // 判断标题
      if (title == "") {
        this.$message({
          message: "标题为必填项!",
          type: "warning"
        });
        return false;
      }

      // 判断文章简介
      if (this.show&&!intro) {
        this.$message({
          message: "简介为必填项!",
          type: "warning"
        });
        return false;
      }

      //判断是否正在上传附件
      if ((this.limt = false)) {
        this.$message({
          message: "附件上传中",
          type: "warning",
          duration: "1000"
        });
        return 
      } 
      this.loading = true; //隐藏
      let data = { 
        uid:this.userInfo.id,     //用户id
        uname:this.userInfo.name,    //用户昵称
        type:2,   
        title,                  //标题
        context:content||'',   //内容
        fileLink:file||'',     //附件
        link:reference||''     //外部链接
      };

      if(this.show){
        data.info = intro;
        data.coverImg = img||'';
        data.type = 1;
      }
      publishWK(data).then(res=>{
        this.$message({
          message: res.message,
          type: res.success?"success":"warning",
          duration: "1000"
        });

        
        if(res.success){
          setTimeout(() => {
            this.loading = false; //隐藏
            this.$router.go(-1);
          }, 1000);
        }else{
          this.loading = false; //隐藏
        }

      })
    },

    handleRemove(file, fileList) {
      console.log(file, fileList);
    },

    //上传附件
    handlePreview(file, fileList) {
      this.form.file = file.data;
    },

    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    
  }
};
</script>

<style scoped>
.Release {
  background-color: #ffffff;
  margin: 17px 310px 0 340px;
}

.el-menu-item {
  margin-left: 138px;
}

.el-form-item {
  margin-top: 43px;
  margin-bottom: 22px;
}

.el-form {
  margin: 25px;
  padding-bottom: 25px;
}

.el-form button {
  float: right;
  margin-right: 20px;
}

.kws {
  border: 1px solid rgba(210, 210, 210, 1);
  padding: 10px;
  height: 90px;
}

.kws-up {
  padding: 10px;
  font-size: 14px;
}

.kws-down {
  position: relative;
  min-height: 38px;
}

.kws-up .sub-modify {
  float: right;
  color: #0084ff;
  cursor: pointer;
}

.kws-down .keyword {
  display: inline-block;
  height: 20px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(210, 210, 210, 1);
  border-radius: 14px;
  padding: 3px 10px;
  line-height: 20px;
  vertical-align: middle;
  margin-left: 5px;
  font-size: 12px;
}

.kws-down .keyword .kw-close {
  vertical-align: top;
  display: inline-block;
  width: 13px;
  height: 8px;
  line-height: 8px;
  margin-left: 5px;
  background-size: 8px 8px;
  background-repeat: no-repeat;
  position: relative;
  right: -5px;
  /* border: 1px solid red; */
  cursor: pointer;
}

.kws-down .keyword .kw-close:hover,
.kws-down .add-kw:hover {
  color: red;
}

.kws-down .add-kw {
  position: absolute;
  right: 0;
  bottom: 4px;
  height: 28px;
  line-height: 28px;
  margin-left: 10px;
  padding: 3px 10px;
  cursor: pointer;
  vertical-align: middle;
  font-size: 12px;
}

.kws-down .add-kw input {
  height: 26px;
}

.up-img:hover {
  background-color: rgba(210, 210, 210, 1);
}

.up-img {
  margin-left: 10px;
  display: inline-block;
  width: 58px;
  height: 51px;
  border: 1px solid rgba(210, 210, 210, 1);
  border-radius: 3px;
  background-image: url(~@/assets/icon/add-img.png);
  background-repeat: no-repeat;
  background-position-x: 14px;
  background-position-y: 10px;
  position: relative;
  left: -20px;
  top: -6px;
  background-color: white;
  cursor: pointer;
  /* border: 1px solid red; */
}

.fenmian {
  /* border: 1px solid red; */
  display: inline-block;
  color: grey;
  font-size: 10px;
}
</style>
